module.exports = __webpack_public_path__ + "static/media/plus.cd4982ee.svg";